
export const SCREEN_SIZES = {
    SMALL: 1280,
    MEDIUM: 1550
}